import getSectionsData from './get-sections-data';
import getActiveTab from './get-active-tab';

export { getSectionsData, getActiveTab };
